import { Grid, IconButton } from '@mui/material';
import React, { useRef, useState } from 'react';
// import ReactToPrint from 'react-to-print';
import PieChartRelatorio from '../PieChartRelatorio';
import { usePallet } from "../../../../contexts/PalletContext";
import styled from 'styled-components';
import legis_agenda from "../../../../img/logo_legis_alta.png";
import PrintIcon from '@mui/icons-material/Print';
import { isMobile, isWindows } from 'react-device-detect';
import legis_agenda2 from "../../../../img/legis_agenda2.png";
import { fontSize } from '@mui/system';
import RelatorioService from "../../../../services/RelatoriosService";
import { format } from 'date-fns';
import { useParams } from 'react-router-dom';
import CircularLoading from '../../../../components/CircularLoading';
import { useQuery } from '../../../../utils/utils';



export default function RelatorioProposicoesPorAtivoInativo() {
    const { pallet } = usePallet();
    const { dtIni } = useParams() as any;
    const { dtFin } = useParams() as any;
    const [loading, setLoading] = useState(false)

    let filter = useQuery().get('filter');
    const [filtro, setFiltro] = useState(filter)
    const [countAtivo, setCountAtivo] = useState()
    const [countInativo, setCountInativo] = useState()

    const [dataAtivo, setDataAtivo] = useState([])
    const [dataInativo, setDataInativo] = useState([])

    //let esferaTipo = filter.substring(27, 29)

    let filtrotitle = []

    try { filtrotitle = JSON.parse(filter) } catch { filtrotitle = [] };
    
    let esferaTipo = (filtrotitle.length>0 ? filtrotitle[0].value : "Geral")

    const Imprimir = () => {
        window.print()
    }

    React.useEffect(() => {
        setLoading(true)

        if (
            String(format(new Date(dtIni), "yyyy")).slice(0, 1) !== "0" &&
            String(format(new Date(dtFin), "yyyy")).slice(0, 1) !== "0"
        ) {

            setTimeout(() => {
            RelatorioService.GetProposicoesPorAtivoInativo(
                format(new Date(dtIni), "yyyy-MM-dd"),
                format(new Date(dtFin), "yyyy-MM-dd 23:59:00.000"),
                String(filtro)
            ).then(async res => {
                setCountAtivo(res?.data?.universo?.ativas)
                setCountInativo(res?.data?.universo?.inativas)

                setDataAtivo(res?.data?.universoTipos?.propTipoAtivo)
                setDataInativo(res?.data?.universoTipos?.propTipoInativo)
                setLoading(false)
            })
            }, 1000);
        }
    }, []);

    const CheckEsfera = (select) => {
        switch (select) {
            case 'F':
                return 'Federal'
            case 'E':
                return 'Estadual'
            case 'M':
                return 'Municipal'
            default:
                return 'Federal'
        }
    }

    return (
        <div>
            <div className="relativeCSS">
                <style type="text/css" media="print">
                    {"\
                        @page { size: A4; }\
                    "}
                </style>
                <div className="flash" />
                <div style={{ width: '1000px', WebkitPrintColorAdjust: 'exact' }} >
                    <table className="testClass" style={{ width: '1000px' }} >
                        <thead>
                            <tr>
                                <td>
                                    <Grid container style={{
                                        padding: "20px",
                                        backgroundColor: `${pallet.general.color1}`,
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        height: '70px'
                                    }}>
                                        <Grid style={{}}>
                                            <img style={{ width: '100px' }} src={legis_agenda} />
                                        </Grid>
                                        <Grid style={{
                                            color: 'white',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size12}`
                                        }}>
                                            Monitoramento Inteligente no Poder Legislativo
                                        </Grid>
                                        <Grid>
                                            <IconButton onClick={Imprimir} style={{ color: 'white' }} aria-label="upload picture" component="span">
                                                <PrintIcon />
                                            </IconButton>
                                        </Grid>

                                    </Grid>
                                </td>
                            </tr>
                        </thead>
                        <tbody style={{
                            width: '900px',
                            // display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                        }}>
                            <tr>
                                <td>
                                    <Grid container style={{
                                        width: '990px',
                                        padding: '30px'
                                    }}>
                                        <Grid style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "left",
                                            // alignItems: "left",
                                        }}>
                                            <img style={{ width: '100px' }} src={legis_agenda2} />
                                        </Grid>
                                        <Grid style={{ marginLeft: '50px' }}>
                                            <Grid style={{
                                                fontFamily: `${pallet.general.fontFamily}`,
                                                fontSize: `${pallet.general.size16}`,
                                            }}>
                                                Relatório / {esferaTipo}
                                            </Grid>
                                            <Grid style={{
                                                fontFamily: `${pallet.general.fontFamily}`,
                                                fontSize: '20px',
                                                fontWeight: pallet.general.weight_bold,
                                                marginTop: '8px'
                                            }}>
                                                Proposições Classificadas por "Ativo" ou "Inativo"
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </td>
                            </tr>
                            <tr >
                                <td>
                                    {loading ?
                                        <CircularLoading
                                            size={100}
                                            top={isMobile ? "37%" : "40%"}
                                            left={isMobile ? "6%" : "16%"}
                                            zIndex={2}
                                        />
                                        :
                                        <Grid style={{
                                            width: '990px',
                                            paddingLeft: '5px',
                                            marginTop: '30px'
                                        }}>
                                            <PieChartRelatorio
                                                title="PERÍODO DE APRESENTAÇÃO"
                                                dtIni={dtIni}
                                                dtFin={dtFin}
                                                labels={[
                                                    {
                                                        key: "Ativo",
                                                        data: Number(countAtivo),
                                                        color: `${pallet.color.charts.green}`,
                                                        url: '/proposicao?filtro=[{"key":"esfera","label":"ESFERA: Federal","value":"Federal"},{"key":"emTramitacao","label":"EM TRAMITAÇÃO: Sim","value":true},{"key":"dataIni","label":"DATA APRESENTAÇÃO INICIAL: ' +
                                                        format(new Date(dtIni), "yyyy-MM-dd") +
                                                        '","value" : "' +
                                                        format(new Date(dtIni), "MM/dd/yyyy") +
                                                        '"},{"key":"dataFin","label":"DATA APRESENTAÇÃO FINAL: ' +
                                                        format(new Date(dtFin), "yyyy-MM-dd") +
                                                        '","value" : "' +
                                                        format(new Date(dtFin), "MM/dd/yyyy") +
                                                        '"},{"key":"visualizacao","label":"VISUALIZAÇÃO: Seguidas","value":"Seguidas"}]'
                                                    },
                                                    {
                                                        key: "Inativo",
                                                        data: Number(countInativo),
                                                        color: `${pallet.color.charts.red}`,
                                                        url: '/proposicao?filtro=[{"key":"esfera","label":"ESFERA: Federal","value":"Federal"},{"key":"emTramitacao","label":"EM TRAMITAÇÃO: Não","value":false},{"key":"visualizacao","label":"VISUALIZAÇÃO: Seguidas","value":"Seguidas"},{"key":"dataIni","label":"DATA APRESENTAÇÃO INICIAL: ' +
                                                        format(new Date(dtIni), "yyyy-MM-dd") +
                                                        '","value" : "' +
                                                        format(new Date(dtIni), "MM/dd/yyyy") +
                                                        '"},{"key":"dataFin","label":"DATA APRESENTAÇÃO FINAL: ' +
                                                        format(new Date(dtFin), "yyyy-MM-dd") +
                                                        '","value" : "' +
                                                        format(new Date(dtFin), "MM/dd/yyyy") +
                                                        '"}]'
                                                    },
                                                ]}
                                            />
                                        </Grid>
                                    }
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table>
                        <tbody>
                            <tr>
                                <Grid style={{marginTop: '70px'}}>
                                    TOTAL: {Number(countAtivo) + Number(countInativo)}
                                </Grid>
                                <Grid style={{
                                    fontSize: `${pallet.general.size18}`,
                                    fontFamily: `${pallet.general.fontFamily}`,
                                    fontWeight: pallet.general.weight_600
                                }}>
                                    | ATIVO
                                </Grid>
                            </tr>
                        </tbody>
                    </table>
                    <Grid style={{
                        border: `1px solid #e0e0e0`,
                        marginTop: '20px',
                        borderRadius: '7px'
                    }}>
                        <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                            <tbody>
                                <tr>
                                    <Grid container
                                        display='flex'
                                        justifyContent={'flex-start'}
                                        direction='row'
                                        style={{
                                            height: '50px',
                                            backgroundColor: `${pallet.backgroundGeneralPage}`,
                                            borderTopLeftRadius: '7px',
                                            borderTopRightRadius: '7px'
                                        }}
                                    >
                                        <Grid style={{
                                            width: '495px',
                                            paddingTop: '15px',
                                            paddingLeft: '25px',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size14}`,
                                            color: `${pallet.textColorSecondary}`,
                                            fontWeight: pallet.general.weight_600
                                        }}>
                                            TIPO DE PROPOSIÇÃO
                                        </Grid>
                                        <Grid style={{
                                            width: '495px',
                                            paddingTop: '15px',
                                            paddingLeft: '25px',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size14}`,
                                            color: `${pallet.textColorSecondary}`,
                                            fontWeight: pallet.general.weight_600
                                        }}>
                                            QUANTIDADE
                                        </Grid>
                                    </Grid>
                                </tr>
                            </tbody>
                        </table>
                        {dataAtivo?.map(x => {
                            return (
                                <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                                    <tbody>
                                        <tr>
                                            <Grid container
                                                display='flex'
                                                justifyContent={'flex-start'}
                                                direction='row'
                                                style={{
                                                    height: '50px',
                                                    borderTop: `1px solid #e0e0e0`
                                                }}
                                            >
                                                <Grid style={{
                                                    width: '495px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '25px',
                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                    fontSize: `${pallet.general.size14}`,
                                                }}>
                                                    {x.tipo}
                                                </Grid>
                                                <Grid style={{
                                                    width: '495px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '25px',
                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                    fontSize: `${pallet.general.size14}`,
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => window.open('/proposicao?filtro=[{"key":"esfera","label":"ESFERA: Federal","value":"Federal"},{"key":"tipo","label":"TIPO : '+ x.tipo +'","value":"'+ x.tipo +'" },{"key":"emTramitacao","label":"EM TRAMITAÇÃO: Sim","value":true},{"key":"visualizacao","label":"VISUALIZAÇÃO: Seguidas","value":"Seguidas"},{"key":"dataIni","label":"DATA APRESENTAÇÃO INICIAL: ' +
                                                        format(new Date(dtIni), "yyyy-MM-dd") +
                                                        '","value" : "' +
                                                        format(new Date(dtIni), "MM/dd/yyyy") +
                                                        '"},{"key":"dataFin","label":"DATA APRESENTAÇÃO FINAL: ' +
                                                        format(new Date(dtFin), "yyyy-MM-dd") +
                                                        '","value" : "' +
                                                        format(new Date(dtFin), "MM/dd/yyyy") +
                                                        '"}]','_blank')} >
                                                    {x.qtd}
                                                </Grid>
                                            </Grid>
                                        </tr>
                                    </tbody>
                                </table>
                            )
                        })}


                    </Grid>
                    <table>
                        <tbody>
                            <tr>
                                <Grid style={{
                                    marginTop: '70px',
                                    fontSize: `${pallet.general.size18}`,
                                    fontFamily: `${pallet.general.fontFamily}`,
                                    fontWeight: pallet.general.weight_600
                                }}>
                                    | INATIVO
                                </Grid>
                            </tr>
                        </tbody>
                    </table>
                    <Grid style={{
                        border: `1px solid #e0e0e0`,
                        marginTop: '20px',
                        borderRadius: '7px'
                    }}>
                        <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                            <tbody>
                                <tr>
                                    <Grid container
                                        display='flex'
                                        justifyContent={'flex-start'}
                                        direction='row'
                                        style={{
                                            height: '50px',
                                            backgroundColor: `${pallet.backgroundGeneralPage}`,
                                            borderTopLeftRadius: '7px',
                                            borderTopRightRadius: '7px'
                                        }}
                                    >
                                        <Grid style={{
                                            width: '495px',
                                            paddingTop: '15px',
                                            paddingLeft: '25px',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size14}`,
                                            color: `${pallet.textColorSecondary}`,
                                            fontWeight: pallet.general.weight_600
                                        }}>
                                            TIPO DE PROPOSIÇÃO
                                        </Grid>
                                        <Grid style={{
                                            width: '495px',
                                            paddingTop: '15px',
                                            paddingLeft: '25px',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size14}`,
                                            color: `${pallet.textColorSecondary}`,
                                            fontWeight: pallet.general.weight_600
                                        }}>
                                            QUANTIDADE
                                        </Grid>
                                    </Grid>
                                </tr>
                            </tbody>
                        </table>
                        {dataInativo?.map(x => {
                            return (
                                <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                                    <tbody>
                                        <tr>
                                            <Grid container
                                                display='flex'
                                                justifyContent={'flex-start'}
                                                direction='row'
                                                style={{
                                                    height: '50px',
                                                    borderTop: `1px solid #e0e0e0`
                                                }}
                                            >
                                                <Grid style={{
                                                    width: '495px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '25px',
                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                    fontSize: `${pallet.general.size14}`,
                                                }}>
                                                    {x.tipo}
                                                </Grid>
                                                <Grid style={{
                                                    width: '495px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '25px',
                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                    fontSize: `${pallet.general.size14}`,
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => window.open('/proposicao?filtro=[{"key":"esfera","label":"ESFERA: Federal","value":"Federal"},{"key":"tipo","label":"TIPO : '+ x.tipo +'","value":"'+ x.tipo +'" },{"key":"emTramitacao","label":"EM TRAMITAÇÃO: Não","value":false},{"key":"visualizacao","label":"VISUALIZAÇÃO: Seguidas","value":"Seguidas"},{"key":"dataIni","label":"DATA APRESENTAÇÃO INICIAL: ' +
                                                        format(new Date(dtIni), "yyyy-MM-dd") +
                                                        '","value" : "' +
                                                        format(new Date(dtIni), "MM/dd/yyyy") +
                                                        '"},{"key":"dataFin","label":"DATA APRESENTAÇÃO FINAL: ' +
                                                        format(new Date(dtFin), "yyyy-MM-dd") +
                                                        '","value" : "' +
                                                        format(new Date(dtFin), "MM/dd/yyyy") +
                                                        '"}]','_blank')} >
                                                    {x.qtd}
                                                </Grid>
                                            </Grid>
                                        </tr>
                                    </tbody>
                                </table>
                            )
                        })}
                    </Grid>
                </div>
            </div>
            {/* </Grid> */}
        </div>
    );
};
